<template>
  <div class="setPhone">
    <div class="contentItem">
      <set-people
        ref="SetPeople"
        multiple
        :from="workFlowData.type == 'task' ? 'Project' : 'App'"
        :people-group="flowConnectedData | screenPeople"
        name="通知人员"
        :flow-info="nodeInfo"
        :project-id="workFlowData.appId"
        :app-id="workFlowData.appId"
        :is-required="false"
      ></set-people>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        通知手机号
      </div>
      <tree-select
        multiple
        v-model="tempNodeData.telephones"
        :group-list="filteredWorkflowVarGroupControl"
      ></tree-select>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        短信签名内容
        <span class="require-flag">*</span>
      </div>
      <el-input v-model="tempNodeData.sign" placeholder="请输入签名内容"></el-input>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        短信模板ID
        <span class="require-flag">*</span>
      </div>
      <el-input v-model="tempNodeData.templateCode" placeholder="请输入短信模板ID"></el-input>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        模板变量
      </div>
      <div class="key-value" v-if="!_.isEmpty(params)">
        <div style="width: 43%">短信模板变量</div>
        <div style="flex: 1">工作表变量</div>
      </div>
      <div class="template-var-list">
        <div v-for="(param, index) in params" :key="index">
          <div class="template-var">
            <div class="item">
              <div style="display: flex; align-items: center; position: relative;">
                <span class="required">
                  *
                </span>
                <el-input v-model="param.code" placeholder="请输入变量"></el-input>
              </div>
            </div>
            <span class="divider">→</span>
            <div class="item">
              <tree-select
                v-model="param.sheetVar"
                :group-list="workflowVarGroupString"
              ></tree-select>
            </div>
            <span style="margin-left: 6px;" @click="delParam(index)">
              <svg-icon
                style="font-size: 18px;"
                icon-class="workflow_script_del-script1"
              ></svg-icon>
            </span>
          </div>
        </div>
        <div class="mTop10">
          <span class="add-item" @click="addParam">+ 添加变量</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/common"
import SetPeople from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SetPeople/SetPeople"
import Filters from "../../../mixin/filters"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { filterTreeVarGroup, transOldExpr } from "@/utils/workFlow"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"

export default {
  name: "setPhone",
  components: { TreeSelect, SetPeople },
  props: {
    nodeInfo: Object,
    workFlowData: Object,
    workflowVarGroup: Array,
    flowConnectedData: Array,
    workflowVarGroupString: Array
  },
  data() {
    return {
      tempNodeData: {},
      params: [],
      param: {
        code: "",
        sheetVar: ""
      }
    }
  },
  mixins: [Filters, mixin],
  computed: {
    filteredWorkflowVarGroupControl() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => control?._type === "telephone"
      })
    }
  },
  created() {
    this.tempNodeData = deepClone(this.nodeInfo).data?.phoneMessage
  },
  methods: {
    init() {
      this.tempNodeData.telephones = this.tempNodeData.telephones.map(tel => transOldExpr(tel))
      if (!this._.isEmpty(this.tempNodeData.params)) {
        this._.keys(this.tempNodeData.params).forEach(key => {
          this.params.push({ code: key, sheetVar: this.tempNodeData.params[key] })
        })
      }
      this.$nextTick(() => {
        this.$refs.SetPeople.init()
      })
    },
    getParams() {
      if (this.params.length) {
        this.params.forEach(param => {
          this.$set(this.tempNodeData.params, param.code, param.sheetVar)
        })
      }
    },
    beforeOutput() {
      if (!this.tempNodeData.telephones.length && !this.$refs.SetPeople.$data.people?.length)
        return { result: false, msg: "人员和手机号必选其一！" }
      if (!this.tempNodeData.sign) return { result: false, msg: "未填写签名！" }
      if (!this.tempNodeData.templateCode) return { result: false, msg: "未填写短信模板ID！" }
      if (!this.verifyPhonePairs(this.params, "submit"))
        return { result: false, msg: "模板变量填写有误！" }
      return this.$refs.SetPeople.output()
    },
    delParam(index) {
      this.params.splice(index, 1)
    },
    addParam() {
      if (!this.verifyPhonePairs(this.params, "add")) return
      this.params.push(this.$options.data().param)
    }
  }
}
</script>

<style lang="scss">
.setPhone {
  .contentItem {
    .itemTitle {
      margin-bottom: 10px;
    }
    .var-title {
      font-weight: bold;
      margin-bottom: 22px;
    }
    .key-value {
      display: flex;
      text-align: center;
    }
    .template-var-list {
      padding-right: 12px;
      padding-bottom: 150px;
      .template-var {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .item {
          text-align: center;
          flex: 1;
          .required {
            color: red;
            z-index: 10;
            position: absolute;
            margin-left: 8px;
          }
        }
        .divider {
          padding: 10px;
          width: 12px;
        }
      }
    }

    .add-item {
      cursor: pointer;
      color: #9e9e9e;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
</style>
